import {memo} from 'react';
import Chart from "react-apexcharts";
import {Typography} from "@material-tailwind/react";
import {isDarkMode} from "../../App";
import {useTranslation} from "react-i18next";
import Loader from "../../assets/icons/Loader";

export interface BarChartsProps {
    series: {
        name: string,
        data: number[]
    },
    labels: string[],
    isLoading: boolean;
}

const BarChart = ({series, labels, isLoading = true}: BarChartsProps) => {
    const {t} = useTranslation();
    const colors = [
        '#607d8b',
        '#ffca28',
        '#9ccc65',
        '#26a69a',
        '#d84315',
        '#039be5',
        '#9c27b0',
        '#ff5722',
        '#d84315',
        '#ef5350',
        '#33691e',
        '#00695c'
    ];

    const element = document.getElementById('device_types');
    const hasLength = series.data.length && typeof series.data[0] !== 'undefined' && series.data[0];
    const emptyLength = 10 - series.data.length;
    const emptyArray = [...Array(emptyLength).fill(0)];
    const data = series.data.length ? (series.data.length < 10 ? series.data.concat(emptyArray) : series.data) : [];
    const titles = labels.length ? (labels.length < 10 ? labels.concat(emptyArray.fill('')) : labels) : [];

    if (hasLength) {
        setTimeout(function () {
            const elements = document.querySelectorAll('div[type="bar"]').item(0).getElementsByClassName('apexcharts-datalabel');
            for (let i = 0; i < elements.length; i++) {
                // @ts-expect-error can be undefined
                if (elements[i] && parseInt(elements[i].innerHTML) === 0){
                    // @ts-expect-error can be undefined
                    elements[i].innerHTML = '';
                }
            }
        }, 1);
    }

    return <>
        {hasLength ? <Chart type="bar"
                            width={element ? element.offsetWidth - 16 : '100%'}
                            height={element ? element.offsetHeight - 100 : '100%'}
                            series={[
                                {
                                    name: series.name,
                                    data
                                }
                            ]}
                            options={{
                                colors: isDarkMode ? colors.reverse() : colors,
                                plotOptions: {
                                    bar: {
                                        borderRadius: 4,
                                        horizontal: true,
                                        dataLabels: {
                                            position: 'bottom'
                                        }
                                    }
                                },
                                grid: {
                                    borderColor: 'transparent'
                                },
                                dataLabels: {
                                    enabled: true,
                                    textAnchor: 'middle',
                                    offsetX: 10,
                                    style: {
                                        colors: ['#ffffff']
                                    }
                                },
                                yaxis: {
                                    labels: {
                                        maxWidth: element ? element.offsetWidth * 0.8 : 180,
                                        style: {
                                            cssClass: 'my-2'
                                        }
                                    }
                                },
                                xaxis: {
                                    categories: titles,
                                    axisTicks: {
                                        show: false,
                                    },
                                    axisBorder: {
                                        show: true,
                                        color: isDarkMode ? '#666' : "#ccc"
                                    },
                                    labels: {
                                        show: true,
                                    }
                                },
                                chart: {
                                    animations: {
                                        enabled: false
                                    },
                                    zoom: {
                                        enabled: false
                                    },
                                    toolbar: {
                                        show: false
                                    },
                                    background: 'transparent'
                                },
                                tooltip: {
                                    theme: isDarkMode ? 'dark' : 'light',
                                    cssClass: 'text-center'
                                },
                                theme: {
                                    mode: isDarkMode ? 'dark' : 'light'
                                },
                                legend: {
                                    show: false
                                }
                            }}
        /> : <>
            <Chart type="bar"
                   width={element ? element.offsetWidth - 16 : '100%'}
                   height={element ? element.offsetHeight - 100 : '100%'}
                   series={[{name: 'No data', data: []}]}
                   options={{
                       labels: labels,
                       legend: {
                           show: false
                       },
                       dataLabels: {
                           enabled: false,
                       },
                       colors: ['#cfd8dc'],
                       plotOptions: {
                           bar: {
                               borderRadius: 2,
                               horizontal: true,
                           }
                       },
                       chart: {
                           animations: {
                               enabled: false
                           },
                           zoom: {
                               enabled: false
                           },
                           toolbar: {
                               show: false
                           },
                           background: 'transparent'
                       },
                       grid: {
                           borderColor: '#666'
                       },
                       states: {
                           active: {
                               filter: {
                                   type: 'none'
                               },
                           },
                           hover: {
                               filter: {
                                   type: 'none'
                               }
                           }
                       },
                       tooltip: {
                           enabled: false
                       },
                       theme: {
                           mode: isDarkMode ? 'dark' : 'light'
                       }
                   }}
            />
            {!isLoading ? <Typography variant="small" className="mb-4 text-center absolute w-full top-1/2">{t('No data')}</Typography>: ''}
        </>}
        {isLoading ? <div
            className="absolute w-full h-full bg-white dark:bg-black top-0 left-0 opacity-30 flex items-center justify-center rounded-xl">
            <Loader width="w-8 h-8" colors="text-teal-600 fill-white"/>
        </div> :''}
    </>
}

export default memo(BarChart);
